import { Card, Flex, theme } from 'antd';
import type { ReactNode } from 'react';

type PreSalesQuestionnaireCardProps = {
  children: ReactNode;
  footer: ReactNode;
  isResult?: boolean;
};

export const PreSalesQuestionnaireCard = ({
  children,
  footer,
  isResult = false,
}: PreSalesQuestionnaireCardProps) => {
  const { token } = theme.useToken();

  return (
    <Card
      className={`bp-presales-questionnaire${isResult ? ' bp-presales-questionnaire--result' : ''}`}
      styles={{
        body: {
          display: 'flex',
          flex: '1 1 auto',
          flexDirection: 'column',
          minHeight: 0,
          overflow: 'hidden',
          padding: 0,
        },
      }}
    >
      <Flex
        vertical
        gap={isResult ? 14 : 16}
        className={`bp-presales-questionnaire__content${isResult ? ' bp-presales-questionnaire__result-content' : ''}`}
        style={{
          flex: '1 1 auto',
          minHeight: 0,
          overflowY: 'auto',
          padding: token.paddingLG,
        }}
      >
        {children}
      </Flex>
      {footer && <Flex
        component="footer"
        align="center"
        justify="flex-end"
        gap={8}
        className="bp-presales-questionnaire__footer"
        style={{
          flex: '0 0 auto',
          padding: `${token.paddingSM}px ${token.padding}px`,
          backgroundColor: token.colorBgContainer,
          borderTop: `${token.lineWidth}px ${token.lineType} ${token.colorBorderSecondary}`,
        }}
      >
        {footer}
      </Flex>}
    </Card>
  );
};
